import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://ml.novaecom.io/api',
  timeout: 30000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const auth = {
  login: (data) => API.post('/auth/login', data),
  register: (data) => API.post('/auth/register', data),
  me: () => API.get('/auth/me'),
  mlConnect: () => API.get('/auth/ml/connect'),
  mlSaveToken: (data) => API.post('/auth/ml/save-token', data),
};

export const dashboard = {
  stats: (days = 30) => API.get(`/dashboard/stats?days=${days}`),
  monthly: () => API.get('/dashboard/monthly'),
  sync: (days = 30) => API.post('/dashboard/sync', { days }),
};

export const costos = {
  getCogs: () => API.get('/costos/cogs'),
  updateCog: (itemId, data) => API.put(`/costos/cogs/${itemId}`, data),
  bulkCogs: (items) => API.post('/costos/cogs/bulk', { items }),
  getGastos: (month) => API.get(`/costos/gastos${month ? `?month=${month}` : ''}`),
  createGasto: (data) => API.post('/costos/gastos', data),
  deleteGasto: (id) => API.delete(`/costos/gastos/${id}`),
};

export const analytics = {
  general: (days = 30) => API.get(`/analytics/general?days=${days}`),
  publicaciones: (days = 30) => API.get(`/analytics/publicaciones?days=${days}`),
};

export const rentabilidad = {
  porPublicacion: (days = 30) => API.get(`/rentabilidad/por-publicacion?days=${days}`),
};

export const inventario = {
  get: () => API.get('/inventario'),
};

export const ml = {
  status: () => API.get('/ml/status'),
  me: () => API.get('/ml/me'),
};

export default API;
